import React from "react";
import ConfirmSignUpForm from "../../components/auth-forms/confirm-signup-form/ConfirmSignUpForm";

export default function ConfirmPage() {
  return (
    <div>
      <ConfirmSignUpForm />
    </div>
  );
}
